/* 
  Recurate / Outerworn - PDP Sorting(Filters)
  @malibu 2022 -
  
  - Note if it was collection page we would leverage Search Spring Filters.
  
  At the PDP level we only have product.variants and chances are limited in availability and size,
  so a simple JS function to take the current DOM rendering and replacing it with what was 
  chosen on the PDP as a filter, etc..
  
*/

Outerworn = {};

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function titleCase(str) {
   var splitStr = str.toLowerCase().split(' ');
   for (var i = 0; i < splitStr.length; i++) {
       // You do not need to check if i is larger than splitStr length, as your for does that for you
       // Assign it back to the array
       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
   }
   // Directly return the joined string
   return splitStr.join(' '); 
}

/* Function Builds out the Filters on page based on current product 

   Inputs:
   - productVariants
   - mobile or desktop views. As there are different selectors.
   
   Output:
   - Specific Filter selectors for Outerworn (Size(waist), Condition, and a General Sort of options)
   
*/   

Outerworn.buildFilters = function(optionsArr, viewport) {
  // console.log(optionsArr);
  
  // General Sort
  var general_sort = `
       <label>Sort</label>
       <select>
         <option value="Newest to Oldest">Newest to Oldest</option>
         <option value="Oldest to Newest">Oldest to Newest</option>
         <option value="Price: Low to High">Price: Low to High</option>
         <option value="Price: High to Low">Price: High to Low</option>
       </select>`;
  
  var gs_selector = $('#general-filter-desktop');
  gs_selector.html("").fadeIn("slow").html(general_sort);
  // Mobile too
  $('#general-filter-mobile').html("").fadeIn("slow").html(general_sort);
  
  // Size and Conditions Filter
  var sizeArr = [];
  var sizeArrAlpha = []; /* when the size is a alpha value */
  var inseamArr = [];
  var sizeInseamArr = []; /* combo */
  var conditionsArr = [];
  for(x = 0; x < optionsArr.length; x++){
    //Size (Waist)
    if (typeof optionsArr[x].variantOp2 != "string" ){           
       sizeArr.push(optionsArr[x].variantOp2);       /* push number size */
    } else {
       sizeArrAlpha.push(optionsArr[x].variantOp2);  /* push letter size */
    }
    
    //Inseam (if needed)
    if (optionsArr[x].variantOp3 != NaN){
       inseamArr.push(optionsArr[x].variantOp3);
    }
    
    sizeInseamArr.push(optionsArr[x].variantCombo);
    conditionsArr.push(optionsArr[x].condition);
  };
  
  
  /* unique em' and sort em' */
  sizeArr = sizeArr.filter(onlyUnique).sort();
  inseamArr = inseamArr.filter(onlyUnique).sort();
  
  
  sizeInseamArr = sizeInseamArr.filter(onlyUnique).sort();
  sizeArrAlpha = sizeArrAlpha.filter(onlyUnique).sort();
  conditionsArr = conditionsArr.filter(onlyUnique).sort();
  
  // console.log(sizeArr);
  
  // Draw out other filters:
  // Waist/Inseam listing
  var size_sort_combo = '<label>Size</label><select><option value="All">All</option>';
  for ( x=0; x< sizeInseamArr.length; x++){
      size_sort_combo = size_sort_combo + '<option value="'+sizeInseamArr[x]+'">'+sizeInseamArr[x]+'</option>';
  }
  size_sort_combo = size_sort_combo + "</select>";
 
   
  var size_sort_alpha = '<label>Size</label><select><option value="All">All</option>';
  for ( x=0; x< sizeArrAlpha.length; x++){
      size_sort_alpha = size_sort_alpha + '<option value="'+String(sizeArrAlpha[x]).toUpperCase()+'">'+String(sizeArrAlpha[x]).toUpperCase()+'</option>';
  }
  size_sort_alpha = size_sort_alpha + "</select>";
  
  // console.log(size_sort_alpha);
  
  /* Condition. added CSS text-transform for capitalizing first character */
  var cond_sort = '<label>Condition</label><select>';
  for ( x=0; x< conditionsArr.length; x++){
     cond_sort = cond_sort + '<option value="'+titleCase(conditionsArr[x])+'">'+titleCase(conditionsArr[x])+'</option>';
  }
  cond_sort = cond_sort + "</select>";
  
 
  /* apply to the selectors in the DOM ;) */
  
  var cond_selector = $('#condition-filter-desktop');
  cond_selector.html("").fadeIn("slow").html(cond_sort);
  //Mobile
  $('#condition-filter-mobile').html("").fadeIn("slow").html(cond_sort);
  
  /* This checks if sizeArr is full of numbers or not which will determine what we push then for size */
  if (sizeArr.length > 0 ){
     // console.log('Size number values');
     var size_selector = $('#size-filter-desktop');
     size_selector.html("").fadeIn("slow").html(size_sort_combo);
     //Mobile
     $('#size-filter-mobile').html("").fadeIn("slow").html(size_sort_combo);
    
  }else{
     // console.log('Size text values');
     var size_selector = $('#size-filter-desktop');
     size_selector.html("").fadeIn("slow").html(size_sort_alpha);
     //Mobile
     $('#size-filter-mobile').html("").fadeIn("slow").html(size_sort_alpha);
  }
}


/* Function Updates DOM based on filtering selects

   Inputs:
   - a string of the filter selected choice
   - optionsArr - there if we need it?
    
*/   

Outerworn.sortMe = function(sortOption, optionsArr) {
    
   //optionsArr is always New to Oldest FYI
   console.log(sortOption);
  
   var mobileselector = $('.variant-listings');
   // var mobileselector = $('.variant-listings-mobile');
   var desktopselector = $('.variant-listings');
   //var desktopselector = $('.variant-list-listing');
   
   var newSortVariantArray = [];  /* what we want to start as the array */
   var followArray = [];          /* follow array to be appended to end of above */
   var choiceselect = sortOption.toLowerCase();
  
   for ( x = 0; x < optionsArr.length ; x++ ){
   // Sort by Size/Condition  
      if ( choiceselect == optionsArr[x].variantCombo || choiceselect == optionsArr[x].variantOp2 || choiceselect == optionsArr[x].condition ) {
            newSortVariantArray.push(optionsArr[x].id);     
      } else {
            followArray.push(optionsArr[x].id);
      }
   }
   var finalArray = newSortVariantArray.concat(followArray);
   
  
   // Oldest to Newest
   if (sortOption == "Oldest to Newest"){ finalArray = finalArray.reverse(); }
  
   // By Price
   console.log(optionsArr);
   if (sortOption == "Price: Low to High" || sortOption == "Price: High to Low") {
      var pArrToSort = [];
      for (x=0;x<optionsArr.length;x++){
        var temp = {};
        temp.id = optionsArr[x].id;
        temp.price_as_cents = optionsArr[x].price_as_cents;
        pArrToSort.push(temp);
      }
      
      // sort based on the price
      pArrToSort = pArrToSort.sort(function(a, b){
         return a.price_as_cents - b.price_as_cents;
      });
      
      finalArray = [];
      for (x=0;x<pArrToSort.length;x++){
        finalArray.push(pArrToSort[x].id);
      }
     
      // if high to low, reverse it. 
      if (sortOption == "Price: High to Low"){
        finalArray = finalArray.reverse();
      }
   
   }
   
   
  
   var NewlyConstructedDOMElement = "";
   //loop the newarray
   for ( x = 0; x < finalArray.length; x++ ){
   //compare variantid to loop of optionsArray inputed
      for( y = 0; y < optionsArr.length; y++ ){
         if (finalArray[x] == optionsArr[y].id){
            var variant = `
               <div class="v-body"><img src="`+optionsArr[y].imgURL+`"/></div>
               <div class="v-body" style="padding-left: 5px;">`+optionsArr[y].variantOp1+`</div>
               <div class="v-body">`+optionsArr[y].variantOp2+`</div>
               <div class="v-body">`+optionsArr[y].variantOp3+`</div>
               <div class="v-body">`+optionsArr[y].condition+`</div>
               <div class="v-body-btn"><button class="bo-table-btn" onclick="recurateAddVariant(`+optionsArr[y].id+`);">Buy for `+optionsArr[y].price+`</button></div>
               <div class="v-body"><a href="#" onclick="recurateModalOn('`+optionsArr[y].productTitle+`','`+optionsArr[y].id+`')">More Info</a></div>`;

            var variant = `
               <div class="variant-listing-container">
                  <div class="main-content">
                     <div class="variant-media">
                     <a href="#" onclick="recurateModalOn('`+optionsArr[y].productTitle+`','`+optionsArr[y].id+`')">
                        <img src="`+optionsArr[y].imgURL+`" />
                     </a>
                     </div>
                     <div class="variant-info">
                        <div class="variant-color variant-option">
                           <p>Color: <span>`+optionsArr[y].variantOp1+`</span></p>
                        </div>
                        <div class="variant-size variant-option">
                           <p>Size: <span>`+optionsArr[y].variantOp2+`</span></p>
                        </div>
                        <div class="variant-condition variant-option">
                           <p>Condition: <span>`+optionsArr[y].condition+`</span></p>
                        </div>
                        <div class="variant-more-info">
                           <a href="#" onclick="recurateModalOn('`+optionsArr[y].productTitle+`','`+optionsArr[y].id+`')">More Info</a>
                        </div>
                        <div class="variant-atc-container">
                           <button class="variant-atc-btn" onclick="recurateAddVariant(`+optionsArr[y].id+`);">Add To Cart - `+optionsArr[y].price+`</button>
                        </div>
                     </div>
                  </div>
                  <div class="variant-atc-container mobile">
                     <button class="variant-atc-btn" onclick="recurateAddVariant(`+optionsArr[y].id+`);">Add To Cart - `+optionsArr[y].price+`</button>
                  </div>
               </div>
            `;
          NewlyConstructedDOMElement = NewlyConstructedDOMElement + variant;
       }
     }
   }
  
  
   var NewlyConstructedDOMElementMobile = "";
   //loop the newarray
   for ( x = 0; x < finalArray.length; x++ ){
   //compare variantid to loop of optionsArray inputed
     for( y = 0; y < optionsArr.length; y++ ){
       if (finalArray[x] == optionsArr[y].id){
          var variant = `
          <div class="v-body"><img src="`+optionsArr[y].imgURL+`"/></div>
          <div class="v-list-item-mobile" style="margin-top: 10px;">
          <div class="product-title-mobile">`+optionsArr[y].productTitle+`</div>
          <div class="v-list-item">Color: <span id="opval-mobile">`+optionsArr[y].variantOp1+`</span></div>
          <div class="v-list-item">Waist: <span id="opval-mobile">`+optionsArr[y].variantOp2+`</span></div>
          <div class="v-list-item">Inseam: <span id="opval-mobile">`+optionsArr[y].variantOp3+`</span></div>
          <div class="v-list-item">Condition: <span id="opval-mobile">`+optionsArr[y].condition+`</span></div>
          <button class="bo-table-btn" onclick="recurateAddVariant(`+optionsArr[y].id+`);">Buy for `+optionsArr[y].price+`</button>
          <div class="v-list-item-more-info"><a href="#" onclick="recurateModalOnMobile('`+optionsArr[y].productTitle+`','`+optionsArr[y].id+`')">More Info</a></div>
          </div>`;

         var variant = `
            <div class="variant-listing-container">
               <div class="main-content">
                  <div class="variant-media">
                  <a href="#" onclick="recurateModalOn('`+optionsArr[y].productTitle+`','`+optionsArr[y].id+`')">
                     <img src="`+optionsArr[y].imgURL+`" />
                  </a>
                  </div>
                  <div class="variant-info">
                     <div class="variant-color variant-option">
                        <p>Color: <span>`+optionsArr[y].variantOp1+`</span></p>
                     </div>
                     <div class="variant-size variant-option">
                        <p>Size: <span>`+optionsArr[y].variantOp2+`</span></p>
                     </div>
                     <div class="variant-condition variant-option">
                        <p>Condition: <span>`+optionsArr[y].condition+`</span></p>
                     </div>
                     <div class="variant-more-info">
                        <a href="#" onclick="recurateModalOn('`+optionsArr[y].productTitle+`','`+optionsArr[y].id+`')">More Info</a>
                     </div>
                     <div class="variant-atc-container">
                        <button class="variant-atc-btn" onclick="recurateAddVariant(`+optionsArr[y].id+`);">Add To Cart - `+optionsArr[y].price+`</button>
                     </div>
                  </div>
               </div>
               <div class="variant-atc-container mobile">
                  <button class="variant-atc-btn" onclick="recurateAddVariant(`+optionsArr[y].id+`);">Add To Cart - `+optionsArr[y].price+`</button>
               </div>
            </div>
         `;
          NewlyConstructedDOMElementMobile = NewlyConstructedDOMElementMobile + variant;
       }
     }
   }
  
   //console.log(NewlyConstructedDOMElement);
   
   desktopselector.html("").fadeIn("slow").html(NewlyConstructedDOMElement);
   desktopselector.css("display","grid !important;"); // strange have to reset display grid ¯\_(ツ)_/¯
   // Mobile too
  
   mobileselector.html("").fadeIn("slow").html(NewlyConstructedDOMElementMobile);
   mobileselector.css("display","grid !important;"); // strange have to reset display grid ¯\_(ツ)_/¯
   
   
}

Outerworn.viewMore = function(){
   // function to remove the SEE MORE btn if all listings are visible
   function seeMore(){
      const listingsToShow = 2
      function allListingsShown(){
         if(document.querySelectorAll('.outerworn-listings .variant-listing-container.hide').length == 0){
            document.querySelector('#view-more').classList.add('hide');
         }
      };
      // if all the listings are visible, return out of the function
      if(document.querySelectorAll('.outerworn-listings .variant-listing-container').length <= listingsToShow){
         allListingsShown();
         Outerworn.stickyColumn();
         return
      };

      // iterate through all the listings and start hiding them
      document.querySelectorAll('.outerworn-listings .variant-listing-container').forEach(function(el,i) {
         // Hide all but the number of desired listings
         if(i<listingsToShow){return};
         el.classList.add('hide');
         Outerworn.stickyColumn();
      });

      // see more btn click events
      document.querySelector('#view-more').addEventListener('click',function(){ 
         document.querySelectorAll('.outerworn-listings .variant-listing-container.hide').forEach(function(el,i){
            // show X number of listings at a time
            if(i>=listingsToShow){return};
            el.classList.remove('hide');

            // If all listings are now visible, hide the SEE MORE btn
            allListingsShown();
            Outerworn.stickyColumn();
         });
      })
  };
  window.addEventListener('load',el => {
      seeMore();
  });
}
Outerworn.stickyColumn = function(){
   function stickyColumn(){
      const header = document.querySelector('sticky-header');
      const columns = document.querySelectorAll('.inner-wrap');

      // Set variables depending on which column is shortest
      if(columns[0].scrollHeight > columns[1].scrollHeight){
         var shortColumn = columns[1];
         var longColumn = columns[0].parentElement;
         var shortColumnThreshold = shortColumn.scrollHeight - window.innerHeight;
         var activationThreshold = shortColumnThreshold + header.scrollHeight;
         var rightSideSticky = true;
      }else{
         var shortColumn = columns[0];
         var longColumn = columns[1].parentElement;
         var shortColumnThreshold = shortColumn.scrollHeight - window.innerHeight;
         var activationThreshold = shortColumnThreshold;
         var rightSideSticky = false;
      }

      var shortColumnWidth = shortColumn.parentElement.scrollWidth - parseInt(window.getComputedStyle(shortColumn.parentElement).paddingLeft) - parseInt(window.getComputedStyle(shortColumn.parentElement).paddingRight);

      // If the page is scrolled past the longest column
      if(document.documentElement.scrollTop > (longColumn.scrollHeight - window.innerHeight)){
         if(rightSideSticky){
            shortColumn.parentElement.style.position = "sticky";
            shortColumn.parentElement.style.top = "0";
   
            shortColumn.style.position = "relative";
            shortColumn.style.top = "unset";
            shortColumn.style.width = "unset";
         }else{
            shortColumn.style.position = "sticky";
            shortColumn.style.top = "0";
         }
         return
      }

      // If the page hasn't scrolled past the bottom of the shortest column
      if(document.documentElement.scrollTop > (activationThreshold)){
         shortColumn.parentElement.style.position = "relative";
         shortColumn.parentElement.style.top = "unset";

         shortColumn.style.position = "fixed";
         shortColumn.style.top = "-" + shortColumnThreshold + "px";
         shortColumn.style.width = shortColumnWidth + "px";
         return
      }else{ // If the page is scrolled to the bottom of the shortest but not the longest column
         shortColumn.parentElement.style.position = "relative";
         shortColumn.parentElement.style.top = "unset";

         shortColumn.style.position = "relative";
         shortColumn.style.top = "unset";
         shortColumn.style.width = "unset";
         return
      }
   };
   window.addEventListener('DOMContentLoaded',function(){
      var isDesktop = window.matchMedia('(min-width:990px)').matches;
      
      window.addEventListener('scroll', e => {
         if(isDesktop){
            stickyColumn();
         }
      });
      window.addEventListener('resize', e => {
         isDesktop = window.matchMedia('(min-width:990px)').matches;
         if(isDesktop){
            stickyColumn();
         }
      });
   });
}


